<template>
    <div class="quiz__campaign__endpoint_video-boxes">
        <div v-if="video !== null && video.length !== 0" class="quiz__campaign__endpoint_video-container" :class="{ 'active' : video_active }">
            <a v-if="video.image_urls !== null" @click.prevent="showVideo" href="#" class="quiz__campaign__endpoint-video-placeholder">
                <img :src="video.image_urls.large" :alt="video_title" />
            </a>
            <div v-if="video.image_urls !== null" class="quiz__campaign__endpoint-video-wrap">
                <div id="endpoint-video"></div>
            </div>
            <div v-else class="quiz__campaign__endpoint-video-wrap">
                <div id="endpoint-video" v-html="video.youtube_embed"></div>
            </div>
        </div>
        <div class="quiz__campaign__endpoint_video-content single title">
            <h2 class="quiz__campaign__endpoint-title">{{ content.title }}</h2>
        </div>
    </div>
</template>
<script>
export default {
    props: ['content'],
    methods: {
        showVideo() {
            console.log('show video');
            this.video_active = true;
            if( null !== this.video.youtube )
            {
                this.onYouTubeIframeAPIReady();
            }
        },
        onYouTubeIframeAPIReady() {
            let vm = this;
            vm.player = new YT.Player('endpoint-video', {
                height: '390',
                width: '640',
                videoId: vm.video.youtube,
                playerVars: { rel: 0 },
                events: {
                    'onReady': vm.onPlayerReady
                }
            });
        },
        onPlayerReady(event) {
           event.target.playVideo();
        },
    },
    mounted(){
        this.video = this.content.data;
        this.video_title = this.content.data.title;

        if( this.content.data.image_urls == null ) {
            this.video_active = true;
        }

    },
    data(){
        return {
            video_active: false,
            video: null,
            video_title: null,
            player: null
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/video.vue